module.exports = __webpack_public_path__ + "static/media/alert-icon.6ba3e408.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Apps/alert-icon.svg
// module id = 114
// module chunks = 0